import React from 'react';
import { Paper, Typography, Box, Chip, Divider } from '@mui/material';
import { FormatDateString } from '../../utils/helper';
import { getStatusColor } from '../catalog/utils/inventory/utils';

interface BaseExport {
  id: number;
  exportType: string;
  status: string;
  errorMessage?: string | null;
  created: Date;
  inventoryTransferItemId?: number | null;
}

interface ExportDetailsProps {
  exports: BaseExport[];
  showSku?: boolean;
  getSkuForItem?: (itemId: number) => string | undefined;
}

const ExportDetails: React.FC<ExportDetailsProps> = ({
  exports,
  showSku = false,
  getSkuForItem,
}) => {
  const renderExportItem = (exportItem: BaseExport) => (
    <Box
      key={exportItem.id}
      sx={{ mb: 2, p: 2, border: 1, borderColor: 'divider', borderRadius: 1 }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <Chip
          label={exportItem.exportType.toUpperCase()}
          color="primary"
          size="small"
          variant="outlined"
        />
        <Chip
          label={exportItem.status.toUpperCase()}
          sx={{ color: getStatusColor(exportItem.status) }}
          size="small"
          variant="outlined"
        />
      </Box>

      {showSku &&
        exportItem.exportType !== 'netsuite' &&
        exportItem.inventoryTransferItemId &&
        getSkuForItem && (
          <Typography variant="body2" color="text.secondary">
            SKU: {getSkuForItem(exportItem.inventoryTransferItemId) || 'N/A'}
          </Typography>
        )}

      <Typography variant="body2" color="text.secondary">
        Created: {FormatDateString(exportItem.created)}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Export Id: {exportItem.id}
      </Typography>

      {exportItem.errorMessage && (
        <Typography variant="body2" color="error" sx={{ mt: 1 }}>
          Error: {exportItem.errorMessage}
        </Typography>
      )}
    </Box>
  );

  return (
    <Paper elevation={1} sx={{ p: 3, mb: 3 }}>
      <Typography variant="h6" gutterBottom>
        Export Details
      </Typography>
      <Divider sx={{ mb: 2 }} />

      {exports?.length > 0 ? (
        <Box>{exports.map(renderExportItem)}</Box>
      ) : (
        <Typography variant="body2" color="text.secondary">
          No exports found
        </Typography>
      )}
    </Paper>
  );
};

export default ExportDetails;
